
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M14.2119 9.03028c-.3994-.11719-.8144.11228-.9297.50975C12.6035 11.8721 10.4307 13.5 8 13.5c-2.07891 0-3.96056-1.1963-4.88862-3H6.25c.41406 0 .75-.3359.75-.75C7 9.33594 6.66406 9 6.25 9h-5c-.414062 0-.75.33594-.75.75v5c0 .4141.335938.75.75.75.41406 0 .75-.3359.75-.75v-3.1912C3.24175 13.6383 5.50416 15 8 15c3.0938 0 5.8584-2.0723 6.7217-5.04003.1162-.39844-.1123-.81447-.5098-.92969zM14.7519.5c-.414 0-.75.335938-.75.75v3.18969C12.7598 2.36109 10.4973 1 8.00194 1 4.90819 1 2.14356 3.07225 1.28028 6.04003c-.11622.39844.11228.81447.50975.92969.40138.11819.81544-.11328.92969-.50975C3.39844 4.12794 5.57128 2.5 8.00194 2.5c2.07896 0 3.96136 1.19628 4.88956 3H9.75194c-.41406 0-.75.33594-.75.75s.33594.75.75.75h4.99996c.4141 0 .75-.33594.75-.75v-5c0-.414062-.3359-.75-.75-.75z"}})])
          )
        }
      }
    